// Copyright (c) 2016 Deere & Company

import {FormattedMessage} from 'react-intl';
import React from 'react';
import {getDefaultState as getCustomerDefaultState} from '@deere/cps-it.warranty-model-factory/lib/customer';
import {getStore} from '../../../store-factory';

let callingApplicationId,
    ckcValue,
    cscUrl,
    returnUrl,
    sourceProgram,
    userId;

const getData = () => {

    callingApplicationId = getStore().getState().appConfig.csc.callingApplicationId;
    ckcValue = getStore().getState().user.details.getCkcValue();
    cscUrl = getStore().getState().appConfig.csc.cscUrl;
    returnUrl = getStore().getState().appConfig.csc.returnUrl;
    sourceProgram = getStore().getState().appConfig.csc.sourceProgram;
    userId = getStore().getState().user.details.id;

};

/* eslint-disable react/no-multi-comp */

export const buildCkcEditFrame = (ckcId, style) => {

    getData();

    const srcUrl = [
        `${cscUrl}customersearch/servlet/SearchComponentViewCustomerServlet`,
        `?returnURL=${returnUrl}`,
        '&returnUserAction=returnCustomer',
        '&targetWindow=_self',
        `&sourceProgram=${sourceProgram}`,
        `&callingApplicationID=${callingApplicationId}`,
        '&showHeader=false',
        `&localeCode=${ckcValue}`,
        `&localUserID=${userId}`,
        `&entityID=${ckcId}`
    ].join('');

    return (
        <iframe
            className={style}
            src={srcUrl}
        />
    );

};

const getCustomerSourceUrl = customer => [
    `${cscUrl}customersearch/servlet/CustomerSearchServlet`,
    '?userAction=initiateSearch',
    `&returnURL=${returnUrl}`,
    '&returnUserAction=returnCustomer',
    '&targetWindow=_self',
    `&sourceProgram=${sourceProgram}`,
    `&callingApplicationID=${callingApplicationId}`,
    '&showHeader=false',
    `&localeCode=${ckcValue}`,
    `&localUserID=${userId}`,
    '&showCustMergeRequest=true',
    '&appNameForMergeHelpText=Warranty',
    `&businessName=${customer.business.primaryName}`,
    `&lastName=${customer.individual.last}`,
    `&firstName=${customer.individual.first}`,
    `&country=${customer.physicalAddress.country}`,
    `&state=${customer.physicalAddress.state}`,
    `&city=${customer.physicalAddress.city}`,
    `&postalCode=${customer.physicalAddress.postalCode}`
].join('');

export const buildCkcSearchFrame = (style, customer = getCustomerDefaultState()) => {

    getData();

    return (
        <iframe
            className={style}
            src={getCustomerSourceUrl(customer)}
        />
    );

};

export const customerDisplayText = customer =>
    customer.displayName ?
        customer.displayName :
        <FormattedMessage id='NO_CUSTOMER_ASSOCIATED'/>;

/* eslint-enable react/no-multi-comp */

export const customerClickHandler = (customer, clickHandler) =>
    customer.ckcId ? clickHandler : null;

export const displayClass = customer => customer.ckcId ?
    'customer-link' :
    'customer-name';



// WEBPACK FOOTER //
// ./src/product/shared/services/customer.js